import { render, staticRenderFns } from "./OrderActionDelete.vue?vue&type=template&id=d825de7e&"
import script from "./OrderActionDelete.vue?vue&type=script&lang=ts&"
export * from "./OrderActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports